import type { JSX } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CatalogSuggestTagsInput } from '@/components/ui';
import { unitFieldTooltips } from '@/features/companies/components/masterDataFieldTooltips';
import type { RefrigerationUnitFormValues } from '../refrigerationUnitFormShared';
import { FieldInfoButton, FormField } from '@/components/blocks/forms';
import { CATALOG_IDS } from '@/data/models/catalog';

/**
 * Custom form field renderer for detector positions.
 *
 * Uses CatalogSuggestTagsInput which requires special handling.
 * This is rendered inline within the "Sistemi di rilevazione" section
 * via SafetySubTabForm's customRenderers prop.
 */
export function DetectorPositionsField(): JSX.Element {
  const { control } = useFormContext<RefrigerationUnitFormValues>();

  return (
    <FormField
      label={
        <FieldInfoButton
          label="Posizioni rilevatori"
          content={unitFieldTooltips.detection.detectorPositions}
        />
      }
      htmlFor="detectors-positions"
      colSpan={2}
    >
      <Controller
        name="detectorPositions"
        control={control}
        render={({ field }) => (
          <CatalogSuggestTagsInput
            catalogId={CATALOG_IDS.PLANT_LOCATIONS}
            value={field.value ?? []}
            onValueChange={field.onChange}
            placeholder="Es: Sala macchine, Locale evaporatori"
            createIdPrefix="ubicazione"
          />
        )}
      />
    </FormField>
  );
}
